import ResourceApiModel from '@/vue/models/ResourceApiModel.js'
import BusinessUnitTaxApiModel from './BusinessUnitTaxApiModel.js'
import ProductUpsertApiModel from './ProductUpsertApiModel.js'
import ResourceSegmentApiModel from './ResourceSegmentApiModel.js'
import ProductGroupApiModel from './ProductGroupApiModel.js'
import CustomFieldDefinitionApiModel from './CustomFieldDefinitionApiModel.js'
import IntegrationFieldDefinitionApiModel from './IntegrationFieldDefinitionApiModel.js'
import LedgerAccountApiModel from './LedgerAccountApiModel.js'
import ExternalProductApiModel from './ExternalProductApiModel.js'
import { has, assoc } from 'ramda'

export default class ProductForEditorApiModel {
  constructor(rawModel) {
    this.Product = new ProductUpsertApiModel(rawModel?.Product)
    this.CustomFieldDefinitions =
      rawModel?.CustomFieldDefinitions?.map(x => new CustomFieldDefinitionApiModel(x)) || []
    this.IntegrationFieldDefinitionsList =
      rawModel?.IntegrationFieldDefinitionsList?.map(
        x => new IntegrationFieldDefinitionApiModel(x),
      ) || []
    this.ResourceSegments =
      rawModel?.ResourceSegments?.map(x => new ResourceSegmentApiModel(x)) || []
    this.SegmentlessProduct = rawModel?.SegmentlessProduct || null
    this.RelatedProductGroups =
      rawModel?.RelatedProductGroups?.map(x => new ProductGroupApiModel(x)) || []
    this.BusinessUnitTaxes = (rawModel?.BusinessUnitTaxes || [{}]).map(
      x => new BusinessUnitTaxApiModel(x),
    )
    this.LedgerAccounts = (rawModel?.LedgerAccounts || [{}]).map(x => new LedgerAccountApiModel(x))
    this.FeatureFlags = mapFeatureFlags(rawModel?.FeatureFlags)
    this.ProductFeeds = rawModel?.ProductFeeds?.map(x => new ExternalProductApiModel(x)) || null
    this.Resources = rawModel?.Resources?.map(r => new ResourceApiModel(r)) || []
  }
}

const mapFeatureFlags = ff => {
  const possibleKeys = [
    'NotSet',
    'CardConnect',
    'Clubspeed',
    'ERP',
    'PublicApi',
    'Gifty',
    'Stripe',
    'StripeTest',
    'Till',
    'Voucherify',
    'Zapier',
    'Zendesk',
    'Innomeer',
    'ExternalPaymentMethod',
    'Briq',
    'Lightspeed',
    'Fast',
    'Entertainment501',
  ]
  return ff
    ? possibleKeys.reduce((a, n) => (has(n, ff) ? assoc(n, new FeatureFlags(ff[n]), a) : a), {})
    : null
}

class FeatureFlags {
  constructor(rawModel) {
    this.ResourceLinkingToExternalResource = rawModel?.ResourceLinkingToExternalResource || null // [ NotAllowed, Single, Multiple ]
    this.UseScheduleRules = rawModel?.UseScheduleRules || null
  }
}
